import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { ICCInfo } from '@curbnturf/entities';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { BASE_API_URL, CONVERGE_GET_TOKEN_URL } from '../network/api-config';

const API_URL = BASE_API_URL + 'credit';

/**
 * Local fork of @curbnturf/credit-card's CreditCardService — same 3-step
 * Converge chain (request-token → hosted process-token → save-token), sourced
 * from cnt-landing's own BASE_API_URL/CONVERGE_GET_TOKEN_URL instead of
 * @curbnturf/entities'.
 */
@Injectable({ providedIn: 'root' })
export class CreditCardApiService {
  private readonly http = inject(HttpClient);

  save(
    requestBody: {
      userId: number;
      firstName: string;
      lastName: string;
      address: string;
      city: string;
      state: string;
      zipcode: string;
    },
    body: {
      ssl_card_number: string;
      ssl_exp_date: string;
      ssl_cvv2cvc2: string;
    },
  ): Observable<ICCInfo> {
    return this.http.post(`${API_URL}/request-token`, requestBody).pipe(
      mergeMap((requestToken) => {
        const headers = new HttpHeaders({
          'Content-Type': 'application/x-www-form-urlencoded',
        });
        return this.http.post(
          CONVERGE_GET_TOKEN_URL,
          {
            context: requestToken,
            fields: { ...body, ssl_txn_auth_token: requestToken },
          },
          {
            headers,
          },
        );
      }),
      mergeMap((convergeResponse) => this.http.post<ICCInfo>(`${API_URL}/token`, convergeResponse)),
    );
  }

  query(userId: number): Observable<ICCInfo> {
    return this.http.get<ICCInfo>(`${API_URL}/token/${userId}`);
  }
}
